import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import VueSidebarMenu from 'vue-sidebar-menu'
import Vuelidate from 'vuelidate'
import Vue3EasyDataTable from 'vue3-easy-data-table';

import './static/css/common.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'vue3-easy-data-table/dist/style.css';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DeleteConfirmationPopup from './components/common/DeleteConfirmationPopup.vue';
import AccessModule from './components/common/AccessModule.vue';
import PageLoader from './components/common/PageLoader.vue';
import StatusAlertMessage from './components/common/StatusAlertMessage.vue';
import BackButton from './components/common/BackButton.vue';
import BaseInput from './components/common/BaseInput.vue';
import BaseSelectBox from './components/common/BaseSelectBox.vue';
import BaseRadioButton from './components/common/BaseRadioButton.vue';
import BaseMultiSelect from './components/common/BaseMultiSelect.vue';
import BaseMultiSelectBox from './components/common/BaseMultiSelectBox.vue';
import BaseButton from './components/common/BaseButton.vue';
import DataTable from './components/common/DataTable.vue';
import GlobalMixins from './helpers/globalMixins';
import BaseDatePicker from './components/common/BaseDatePicker.vue';

let sessionIntervalId;
router.beforeEach((to, from, next) => {
    if (to.name !== 'Login') {
        sessionIntervalId = setInterval(() => {
            store.dispatch('checkSession')
                .then(response => {
                    if (response == false) {
                        clearInterval(sessionIntervalId);
                        var popupModal = new bootstrap.Modal(document.getElementById('popupModal'));
                        popupModal.show();
                    }
                })
                .catch(error => {
                    console.error(error);
                });;
        }, 1000);
    } else {
        clearInterval(sessionIntervalId);
    }
    next();
});

const app = createApp(App);

app.config.globalProperties.$axios = axios;

app.config.errorHandler = function (err, instance, info) {

    let errorMessage = 'An unexpected error occurred. Please try again later.';

    if (err.response) {
        const statusCode = err.response.status;
        const errors = err.response?.data?.data || err.response?.data?.errors || [err.response?.data?.message || err?.message];
        if ( statusCode === 400) {
            errorMessage = errors.map((error, index) => `${index + 1}. ${error.Message || error}`).join('\n');
        } else {
            errorMessage = errors;
        }
    } else if (err.request) {
        errorMessage = 'No response received from the server. Please check your internet connection.';
    } else {
        errorMessage = err.message;
    }
    console.log(err);
    store.dispatch('alertMessages', {message: errorMessage, alert:'danger'});
};
app.config.globalProperties.$notificationMessage = function(message) {
    store.dispatch('alertMessages', message);
};
app
    .component('DeleteConfirmationPopup', DeleteConfirmationPopup)
    .component('AccessModule', AccessModule)
    .component('PageLoader', PageLoader)
    .component('StatusAlertMessage', StatusAlertMessage)
    .component('BackButton', BackButton)
    .component('BaseInput', BaseInput)
    .component('BaseSelectBox', BaseSelectBox)
    .component('BaseRadioButton', BaseRadioButton)
    .component('BaseMultiSelect', BaseMultiSelect)
    .component('BaseMultiSelectBox', BaseMultiSelectBox)
    .component('BaseButton', BaseButton)
    .component('DataTable', DataTable)
    .component('BaseDatePicker', BaseDatePicker)
    .component('VueDatePicker', VueDatePicker)
    .mixin(GlobalMixins)
    .use(store)
    .use(router)
    .use(VueSidebarMenu)
    .use(Vuelidate)
    .component('EasyDataTable', Vue3EasyDataTable)
    .mount('#app')